import type React from "react";

interface SendIconProps {
  className?: string;
  style?: React.CSSProperties;
  hasInput?: boolean;
}

/**
 * SendIcon - ai-companion-next/send-icon.tsx 패턴
 * hasInput prop에 따라 색상 변경
 */
export const SendIcon: React.FC<SendIconProps> = ({
  className,
  style,
  hasInput = false
}) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
  >
    <path
      d="M6.14062 14.8828C5.85417 14.8828 5.61979 14.7917 5.4375 14.6094C5.26042 14.4271 5.17188 14.1875 5.17188 13.8906V4.625L5.27344 1.91406L5.84375 2.24219L3.38281 5.03125L1.61719 6.78125C1.52865 6.86979 1.42708 6.9401 1.3125 6.99219C1.19792 7.04427 1.07031 7.07031 0.929688 7.07031C0.664062 7.07031 0.442708 6.98177 0.265625 6.80469C0.0885417 6.6276 0 6.40365 0 6.13281C0 5.8724 0.101562 5.63802 0.304688 5.42969L5.42188 0.296875C5.51562 0.203125 5.625 0.130208 5.75 0.078125C5.88021 0.0260417 6.01042 0 6.14062 0C6.27604 0 6.40625 0.0260417 6.53125 0.078125C6.66146 0.130208 6.77344 0.203125 6.86719 0.296875L11.9844 5.42969C12.1875 5.63802 12.2891 5.8724 12.2891 6.13281C12.2891 6.40365 12.2005 6.6276 12.0234 6.80469C11.8464 6.98177 11.625 7.07031 11.3594 7.07031C11.2188 7.07031 11.0885 7.04427 10.9688 6.99219C10.8542 6.9401 10.7526 6.86979 10.6641 6.78125L8.89844 5.03125L6.42969 2.24219L7.00781 1.91406L7.10938 4.625V13.8906C7.10938 14.1875 7.01823 14.4271 6.83594 14.6094C6.65885 14.7917 6.42708 14.8828 6.14062 14.8828Z"
      fill={hasInput ? "#222222" : "rgba(255, 255, 255, 0.5)"}
    />
  </svg>
);
